import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import * as types from "@/store/constants/types";
import GeneralUtilsHelper from "@/utils/generalUtils";

var FateSpec =
/*#__PURE__*/
function (_Vue) {
  _inherits(FateSpec, _Vue);

  function FateSpec() {
    _classCallCheck(this, FateSpec);

    return _possibleConstructorReturn(this, _getPrototypeOf(FateSpec).apply(this, arguments));
  }

  _createClass(FateSpec, [{
    key: "horsocopeLang",
    get: function get() {
      return this.$t("common.zodiac." + this.horoScope.toLowerCase());
    }
  }, {
    key: "horoIcon",
    get: function get() {
      return this.$remoteImg("icons/horoscopes/" + this.horoScope + ".png");
    }
  }, {
    key: "timeStamp",
    get: function get() {
      return GeneralUtilsHelper.getTimeStamp();
    }
  }]);

  return FateSpec;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], FateSpec.prototype, "routerPush", void 0);

tslib_1.__decorate([Getter(types.GETTER_HOROSCOPE)], FateSpec.prototype, "horoScope", void 0);

tslib_1.__decorate([Getter(types.GETTER_TODAY_HOROSCOPE_FATE)], FateSpec.prototype, "todayHorosopeFate", void 0);

tslib_1.__decorate([Prop()], FateSpec.prototype, "specData", void 0);

FateSpec = tslib_1.__decorate([Component({
  components: {}
})], FateSpec);
export default FateSpec;